import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export const CommodityCard = ({ item, index = 0 }) => {
  const { content } = useLanguage();
  return (
    <Link
      to={`/matieres-premieres/${item.slug}`}
      data-testid={`commodity-card-${item.slug}`}
      className="group relative flex flex-col overflow-hidden border border-brand-grey bg-white transition-shadow duration-500 hover:shadow-2xl"
    >
      <div className="relative h-[42vh] overflow-hidden">
        <img
          src={item.image}
          alt={item.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-60" />
        <span className="absolute left-5 top-5 font-mono text-xs text-white/90">
          0{index + 1}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-8">
        <h3 className="font-serif text-3xl font-light tracking-tight text-brand-green">
          {item.name}
        </h3>
        <p className="mt-3 flex-1 text-base leading-relaxed text-brand-black/70">
          {item.tagline}
        </p>
        <span className="mt-6 flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-brand-green transition-colors group-hover:text-brand-gold">
          {content.ui.buttons.viewDetails}
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </span>
      </div>
    </Link>
  );
};
